import StaticCrumb from '../components/StaticCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const toolsRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/tools',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: {
                label: 'Tools',
                href: '/agents/:agentId/tools',
            },
        },
    ],
    children: [
        {
            path: 'toolboxes',
            breadcrumbs: [
                {
                    component: StaticCrumb,
                    props: { label: 'Toolboxes', isCurrentPage: true },
                },
            ],
        },
    ],
};
